(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("prop-types"), require("react"), require("ajv"));
	else if(typeof define === 'function' && define.amd)
		define("conditionaleditor", ["PropTypes", "React", "Ajv"], factory);
	else if(typeof exports === 'object')
		exports["conditionaleditor"] = factory(require("prop-types"), require("react"), require("ajv"));
	else
		root["conditionaleditor"] = factory(root["PropTypes"], root["React"], root["Ajv"]);
})(window, function(__WEBPACK_EXTERNAL_MODULE__0__, __WEBPACK_EXTERNAL_MODULE__1__, __WEBPACK_EXTERNAL_MODULE__2__) {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = function(exports) {
/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 		}
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// create a fake namespace object
/******/ 	// mode & 1: value is a module id, require it
/******/ 	// mode & 2: merge all properties of value into the ns
/******/ 	// mode & 4: return value when already ns object
/******/ 	// mode & 8|1: behave like require
/******/ 	__webpack_require__.t = function(value, mode) {
/******/ 		if(mode & 1) value = __webpack_require__(value);
/******/ 		if(mode & 8) return value;
/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
/******/ 		var ns = Object.create(null);
/******/ 		__webpack_require__.r(ns);
/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
/******/ 		return ns;
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 8);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__0__;

/***/ }),
/* 1 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__1__;

/***/ }),
/* 2 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__2__;

/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(4);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(6)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {}

/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(5)(false);
// imports


// module
exports.push([module.i, ".condition-group {\n  border-left:      4px solid slategray;\n  margin:           1rem;\n}\n\n.condition-group > .header {\n  display:          flex;\n  justify-content:  space-between;\n  padding:          0.5rem 1rem;\n  background-color: ghostwhite;\n  border-right:     1px solid whitesmoke;\n}\n\n.condition-group > .item {\n  padding:          0.5rem 1rem;\n  border-bottom:    1px solid whitesmoke;\n  border-right:     1px solid whitesmoke;\n}\n\n.condition-group > .item > * {\n  display: inline-block;\n  width: 30%;\n}\n\n.condition-group > .item > *:last-child {\n  width: 10%;\n  text-align: right;\n}\n\n.condition-group > .condition-group {\n  margin-right: 0;\n}\n\n.condition-group > .header .btn,\n.item .btn {\n  font-family: 'Helvetica Neue';\n  display:  inline-block;\n  border: 1px solid silver;\n  color:            slategray;\n  font-size:        .75rem;\n  font-weight:      bold;\n  text-decoration:  none;\n  padding:          0rem 0.5rem;\n  line-height:      1.2rem;\n  text-align:       center;\n  margin-left:      .25rem;\n}\n\n.condition-group > .header .btn:hover,\n.item .btn:hover {\n  background-color: slategray;\n  color:            white;\n}\n", ""]);

// exports


/***/ }),
/* 5 */
/***/ (function(module, exports) {

/*
	MIT License http://www.opensource.org/licenses/mit-license.php
	Author Tobias Koppers @sokra
*/
// css base code, injected by the css-loader
module.exports = function(useSourceMap) {
	var list = [];

	// return the list of modules as css string
	list.toString = function toString() {
		return this.map(function (item) {
			var content = cssWithMappingToString(item, useSourceMap);
			if(item[2]) {
				return "@media " + item[2] + "{" + content + "}";
			} else {
				return content;
			}
		}).join("");
	};

	// import a list of modules into the list
	list.i = function(modules, mediaQuery) {
		if(typeof modules === "string")
			modules = [[null, modules, ""]];
		var alreadyImportedModules = {};
		for(var i = 0; i < this.length; i++) {
			var id = this[i][0];
			if(typeof id === "number")
				alreadyImportedModules[id] = true;
		}
		for(i = 0; i < modules.length; i++) {
			var item = modules[i];
			// skip already imported module
			// this implementation is not 100% perfect for weird media query combinations
			//  when a module is imported multiple times with different media queries.
			//  I hope this will never occur (Hey this way we have smaller bundles)
			if(typeof item[0] !== "number" || !alreadyImportedModules[item[0]]) {
				if(mediaQuery && !item[2]) {
					item[2] = mediaQuery;
				} else if(mediaQuery) {
					item[2] = "(" + item[2] + ") and (" + mediaQuery + ")";
				}
				list.push(item);
			}
		}
	};
	return list;
};

function cssWithMappingToString(item, useSourceMap) {
	var content = item[1] || '';
	var cssMapping = item[3];
	if (!cssMapping) {
		return content;
	}

	if (useSourceMap && typeof btoa === 'function') {
		var sourceMapping = toComment(cssMapping);
		var sourceURLs = cssMapping.sources.map(function (source) {
			return '/*# sourceURL=' + cssMapping.sourceRoot + source + ' */'
		});

		return [content].concat(sourceURLs).concat([sourceMapping]).join('\n');
	}

	return [content].join('\n');
}

// Adapted from convert-source-map (MIT)
function toComment(sourceMap) {
	// eslint-disable-next-line no-undef
	var base64 = btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap))));
	var data = 'sourceMappingURL=data:application/json;charset=utf-8;base64,' + base64;

	return '/*# ' + data + ' */';
}


/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

/*
	MIT License http://www.opensource.org/licenses/mit-license.php
	Author Tobias Koppers @sokra
*/

var stylesInDom = {};

var	memoize = function (fn) {
	var memo;

	return function () {
		if (typeof memo === "undefined") memo = fn.apply(this, arguments);
		return memo;
	};
};

var isOldIE = memoize(function () {
	// Test for IE <= 9 as proposed by Browserhacks
	// @see http://browserhacks.com/#hack-e71d8692f65334173fee715c222cb805
	// Tests for existence of standard globals is to allow style-loader
	// to operate correctly into non-standard environments
	// @see https://github.com/webpack-contrib/style-loader/issues/177
	return window && document && document.all && !window.atob;
});

var getTarget = function (target, parent) {
  if (parent){
    return parent.querySelector(target);
  }
  return document.querySelector(target);
};

var getElement = (function (fn) {
	var memo = {};

	return function(target, parent) {
                // If passing function in options, then use it for resolve "head" element.
                // Useful for Shadow Root style i.e
                // {
                //   insertInto: function () { return document.querySelector("#foo").shadowRoot }
                // }
                if (typeof target === 'function') {
                        return target();
                }
                if (typeof memo[target] === "undefined") {
			var styleTarget = getTarget.call(this, target, parent);
			// Special case to return head of iframe instead of iframe itself
			if (window.HTMLIFrameElement && styleTarget instanceof window.HTMLIFrameElement) {
				try {
					// This will throw an exception if access to iframe is blocked
					// due to cross-origin restrictions
					styleTarget = styleTarget.contentDocument.head;
				} catch(e) {
					styleTarget = null;
				}
			}
			memo[target] = styleTarget;
		}
		return memo[target]
	};
})();

var singleton = null;
var	singletonCounter = 0;
var	stylesInsertedAtTop = [];

var	fixUrls = __webpack_require__(7);

module.exports = function(list, options) {
	if (typeof DEBUG !== "undefined" && DEBUG) {
		if (typeof document !== "object") throw new Error("The style-loader cannot be used in a non-browser environment");
	}

	options = options || {};

	options.attrs = typeof options.attrs === "object" ? options.attrs : {};

	// Force single-tag solution on IE6-9, which has a hard limit on the # of <style>
	// tags it will allow on a page
	if (!options.singleton && typeof options.singleton !== "boolean") options.singleton = isOldIE();

	// By default, add <style> tags to the <head> element
        if (!options.insertInto) options.insertInto = "head";

	// By default, add <style> tags to the bottom of the target
	if (!options.insertAt) options.insertAt = "bottom";

	var styles = listToStyles(list, options);

	addStylesToDom(styles, options);

	return function update (newList) {
		var mayRemove = [];

		for (var i = 0; i < styles.length; i++) {
			var item = styles[i];
			var domStyle = stylesInDom[item.id];

			domStyle.refs--;
			mayRemove.push(domStyle);
		}

		if(newList) {
			var newStyles = listToStyles(newList, options);
			addStylesToDom(newStyles, options);
		}

		for (var i = 0; i < mayRemove.length; i++) {
			var domStyle = mayRemove[i];

			if(domStyle.refs === 0) {
				for (var j = 0; j < domStyle.parts.length; j++) domStyle.parts[j]();

				delete stylesInDom[domStyle.id];
			}
		}
	};
};

function addStylesToDom (styles, options) {
	for (var i = 0; i < styles.length; i++) {
		var item = styles[i];
		var domStyle = stylesInDom[item.id];

		if(domStyle) {
			domStyle.refs++;

			for(var j = 0; j < domStyle.parts.length; j++) {
				domStyle.parts[j](item.parts[j]);
			}

			for(; j < item.parts.length; j++) {
				domStyle.parts.push(addStyle(item.parts[j], options));
			}
		} else {
			var parts = [];

			for(var j = 0; j < item.parts.length; j++) {
				parts.push(addStyle(item.parts[j], options));
			}

			stylesInDom[item.id] = {id: item.id, refs: 1, parts: parts};
		}
	}
}

function listToStyles (list, options) {
	var styles = [];
	var newStyles = {};

	for (var i = 0; i < list.length; i++) {
		var item = list[i];
		var id = options.base ? item[0] + options.base : item[0];
		var css = item[1];
		var media = item[2];
		var sourceMap = item[3];
		var part = {css: css, media: media, sourceMap: sourceMap};

		if(!newStyles[id]) styles.push(newStyles[id] = {id: id, parts: [part]});
		else newStyles[id].parts.push(part);
	}

	return styles;
}

function insertStyleElement (options, style) {
	var target = getElement(options.insertInto)

	if (!target) {
		throw new Error("Couldn't find a style target. This probably means that the value for the 'insertInto' parameter is invalid.");
	}

	var lastStyleElementInsertedAtTop = stylesInsertedAtTop[stylesInsertedAtTop.length - 1];

	if (options.insertAt === "top") {
		if (!lastStyleElementInsertedAtTop) {
			target.insertBefore(style, target.firstChild);
		} else if (lastStyleElementInsertedAtTop.nextSibling) {
			target.insertBefore(style, lastStyleElementInsertedAtTop.nextSibling);
		} else {
			target.appendChild(style);
		}
		stylesInsertedAtTop.push(style);
	} else if (options.insertAt === "bottom") {
		target.appendChild(style);
	} else if (typeof options.insertAt === "object" && options.insertAt.before) {
		var nextSibling = getElement(options.insertAt.before, target);
		target.insertBefore(style, nextSibling);
	} else {
		throw new Error("[Style Loader]\n\n Invalid value for parameter 'insertAt' ('options.insertAt') found.\n Must be 'top', 'bottom', or Object.\n (https://github.com/webpack-contrib/style-loader#insertat)\n");
	}
}

function removeStyleElement (style) {
	if (style.parentNode === null) return false;
	style.parentNode.removeChild(style);

	var idx = stylesInsertedAtTop.indexOf(style);
	if(idx >= 0) {
		stylesInsertedAtTop.splice(idx, 1);
	}
}

function createStyleElement (options) {
	var style = document.createElement("style");

	if(options.attrs.type === undefined) {
		options.attrs.type = "text/css";
	}

	if(options.attrs.nonce === undefined) {
		var nonce = getNonce();
		if (nonce) {
			options.attrs.nonce = nonce;
		}
	}

	addAttrs(style, options.attrs);
	insertStyleElement(options, style);

	return style;
}

function createLinkElement (options) {
	var link = document.createElement("link");

	if(options.attrs.type === undefined) {
		options.attrs.type = "text/css";
	}
	options.attrs.rel = "stylesheet";

	addAttrs(link, options.attrs);
	insertStyleElement(options, link);

	return link;
}

function addAttrs (el, attrs) {
	Object.keys(attrs).forEach(function (key) {
		el.setAttribute(key, attrs[key]);
	});
}

function getNonce() {
	if (false) {}

	return __webpack_require__.nc;
}

function addStyle (obj, options) {
	var style, update, remove, result;

	// If a transform function was defined, run it on the css
	if (options.transform && obj.css) {
	    result = options.transform(obj.css);

	    if (result) {
	    	// If transform returns a value, use that instead of the original css.
	    	// This allows running runtime transformations on the css.
	    	obj.css = result;
	    } else {
	    	// If the transform function returns a falsy value, don't add this css.
	    	// This allows conditional loading of css
	    	return function() {
	    		// noop
	    	};
	    }
	}

	if (options.singleton) {
		var styleIndex = singletonCounter++;

		style = singleton || (singleton = createStyleElement(options));

		update = applyToSingletonTag.bind(null, style, styleIndex, false);
		remove = applyToSingletonTag.bind(null, style, styleIndex, true);

	} else if (
		obj.sourceMap &&
		typeof URL === "function" &&
		typeof URL.createObjectURL === "function" &&
		typeof URL.revokeObjectURL === "function" &&
		typeof Blob === "function" &&
		typeof btoa === "function"
	) {
		style = createLinkElement(options);
		update = updateLink.bind(null, style, options);
		remove = function () {
			removeStyleElement(style);

			if(style.href) URL.revokeObjectURL(style.href);
		};
	} else {
		style = createStyleElement(options);
		update = applyToTag.bind(null, style);
		remove = function () {
			removeStyleElement(style);
		};
	}

	update(obj);

	return function updateStyle (newObj) {
		if (newObj) {
			if (
				newObj.css === obj.css &&
				newObj.media === obj.media &&
				newObj.sourceMap === obj.sourceMap
			) {
				return;
			}

			update(obj = newObj);
		} else {
			remove();
		}
	};
}

var replaceText = (function () {
	var textStore = [];

	return function (index, replacement) {
		textStore[index] = replacement;

		return textStore.filter(Boolean).join('\n');
	};
})();

function applyToSingletonTag (style, index, remove, obj) {
	var css = remove ? "" : obj.css;

	if (style.styleSheet) {
		style.styleSheet.cssText = replaceText(index, css);
	} else {
		var cssNode = document.createTextNode(css);
		var childNodes = style.childNodes;

		if (childNodes[index]) style.removeChild(childNodes[index]);

		if (childNodes.length) {
			style.insertBefore(cssNode, childNodes[index]);
		} else {
			style.appendChild(cssNode);
		}
	}
}

function applyToTag (style, obj) {
	var css = obj.css;
	var media = obj.media;

	if(media) {
		style.setAttribute("media", media)
	}

	if(style.styleSheet) {
		style.styleSheet.cssText = css;
	} else {
		while(style.firstChild) {
			style.removeChild(style.firstChild);
		}

		style.appendChild(document.createTextNode(css));
	}
}

function updateLink (link, options, obj) {
	var css = obj.css;
	var sourceMap = obj.sourceMap;

	/*
		If convertToAbsoluteUrls isn't defined, but sourcemaps are enabled
		and there is no publicPath defined then lets turn convertToAbsoluteUrls
		on by default.  Otherwise default to the convertToAbsoluteUrls option
		directly
	*/
	var autoFixUrls = options.convertToAbsoluteUrls === undefined && sourceMap;

	if (options.convertToAbsoluteUrls || autoFixUrls) {
		css = fixUrls(css);
	}

	if (sourceMap) {
		// http://stackoverflow.com/a/26603875
		css += "\n/*# sourceMappingURL=data:application/json;base64," + btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))) + " */";
	}

	var blob = new Blob([css], { type: "text/css" });

	var oldSrc = link.href;

	link.href = URL.createObjectURL(blob);

	if(oldSrc) URL.revokeObjectURL(oldSrc);
}


/***/ }),
/* 7 */
/***/ (function(module, exports) {


/**
 * When source maps are enabled, `style-loader` uses a link element with a data-uri to
 * embed the css on the page. This breaks all relative urls because now they are relative to a
 * bundle instead of the current page.
 *
 * One solution is to only use full urls, but that may be impossible.
 *
 * Instead, this function "fixes" the relative urls to be absolute according to the current page location.
 *
 * A rudimentary test suite is located at `test/fixUrls.js` and can be run via the `npm test` command.
 *
 */

module.exports = function (css) {
  // get current location
  var location = typeof window !== "undefined" && window.location;

  if (!location) {
    throw new Error("fixUrls requires window.location");
  }

	// blank or null?
	if (!css || typeof css !== "string") {
	  return css;
  }

  var baseUrl = location.protocol + "//" + location.host;
  var currentDir = baseUrl + location.pathname.replace(/\/[^\/]*$/, "/");

	// convert each url(...)
	/*
	This regular expression is just a way to recursively match brackets within
	a string.

	 /url\s*\(  = Match on the word "url" with any whitespace after it and then a parens
	   (  = Start a capturing group
	     (?:  = Start a non-capturing group
	         [^)(]  = Match anything that isn't a parentheses
	         |  = OR
	         \(  = Match a start parentheses
	             (?:  = Start another non-capturing groups
	                 [^)(]+  = Match anything that isn't a parentheses
	                 |  = OR
	                 \(  = Match a start parentheses
	                     [^)(]*  = Match anything that isn't a parentheses
	                 \)  = Match a end parentheses
	             )  = End Group
              *\) = Match anything and then a close parens
          )  = Close non-capturing group
          *  = Match anything
       )  = Close capturing group
	 \)  = Match a close parens

	 /gi  = Get all matches, not the first.  Be case insensitive.
	 */
	var fixedCss = css.replace(/url\s*\(((?:[^)(]|\((?:[^)(]+|\([^)(]*\))*\))*)\)/gi, function(fullMatch, origUrl) {
		// strip quotes (if they exist)
		var unquotedOrigUrl = origUrl
			.trim()
			.replace(/^"(.*)"$/, function(o, $1){ return $1; })
			.replace(/^'(.*)'$/, function(o, $1){ return $1; });

		// already a full url? no change
		if (/^(#|data:|http:\/\/|https:\/\/|file:\/\/\/|\s*$)/i.test(unquotedOrigUrl)) {
		  return fullMatch;
		}

		// convert the url to a full url
		var newUrl;

		if (unquotedOrigUrl.indexOf("//") === 0) {
		  	//TODO: should we add protocol?
			newUrl = unquotedOrigUrl;
		} else if (unquotedOrigUrl.indexOf("/") === 0) {
			// path should be relative to the base url
			newUrl = baseUrl + unquotedOrigUrl; // already starts with '/'
		} else {
			// path should be relative to current directory
			newUrl = currentDir + unquotedOrigUrl.replace(/^\.\//, ""); // Strip leading './'
		}

		// send back the fixed url(...)
		return "url(" + JSON.stringify(newUrl) + ")";
	});

	// send back the fixed css
	return fixedCss;
};


/***/ }),
/* 8 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
var Control_namespaceObject = {};
__webpack_require__.r(Control_namespaceObject);
__webpack_require__.d(Control_namespaceObject, "DateInput", function() { return Control_DateInput; });
__webpack_require__.d(Control_namespaceObject, "EmailInput", function() { return Control_EmailInput; });
__webpack_require__.d(Control_namespaceObject, "NumberInput", function() { return Control_NumberInput; });
__webpack_require__.d(Control_namespaceObject, "SelectInput", function() { return Control_SelectInput; });
__webpack_require__.d(Control_namespaceObject, "TextInput", function() { return Control_TextInput; });
__webpack_require__.d(Control_namespaceObject, "TimeInput", function() { return Control_TimeInput; });

// EXTERNAL MODULE: external {"commonjs":"react","commonjs2":"react","amd":"React","root":"React"}
var external_commonjs_react_commonjs2_react_amd_React_root_React_ = __webpack_require__(1);
var external_commonjs_react_commonjs2_react_amd_React_root_React_default = /*#__PURE__*/__webpack_require__.n(external_commonjs_react_commonjs2_react_amd_React_root_React_);

// EXTERNAL MODULE: external {"commonjs":"prop-types","commonjs2":"prop-types","amd":"PropTypes","root":"PropTypes"}
var external_commonjs_prop_types_commonjs2_prop_types_amd_PropTypes_root_PropTypes_ = __webpack_require__(0);
var external_commonjs_prop_types_commonjs2_prop_types_amd_PropTypes_root_PropTypes_default = /*#__PURE__*/__webpack_require__.n(external_commonjs_prop_types_commonjs2_prop_types_amd_PropTypes_root_PropTypes_);

// CONCATENATED MODULE: ./src/propTypes/fields.js


// -----------------------------------------------------
// Exports
// -----------------------------------------------------

/* harmony default export */ var propTypes_fields = (external_commonjs_prop_types_commonjs2_prop_types_amd_PropTypes_root_PropTypes_default.a.arrayOf(external_commonjs_prop_types_commonjs2_prop_types_amd_PropTypes_root_PropTypes_default.a.shape({
  label: external_commonjs_prop_types_commonjs2_prop_types_amd_PropTypes_root_PropTypes_default.a.string.isRequired,

  value: external_commonjs_prop_types_commonjs2_prop_types_amd_PropTypes_root_PropTypes_default.a.oneOfType([external_commonjs_prop_types_commonjs2_prop_types_amd_PropTypes_root_PropTypes_default.a.number, external_commonjs_prop_types_commonjs2_prop_types_amd_PropTypes_root_PropTypes_default.a.string, external_commonjs_prop_types_commonjs2_prop_types_amd_PropTypes_root_PropTypes_default.a.bool]).isRequired,

  dataType: external_commonjs_prop_types_commonjs2_prop_types_amd_PropTypes_root_PropTypes_default.a.oneOf(['any', 'boolean', 'boolean_array', 'datetime', 'file', 'id', 'numeric', 'numeric_array', 'signature', 'string_array', 'string', 'time', 'object']).isRequired,

  fieldType: external_commonjs_prop_types_commonjs2_prop_types_amd_PropTypes_root_PropTypes_default.a.oneOf(['attachment', 'checkbox', 'date', 'email', 'number', 'selectMany', 'selectOne', 'text', 'time', 'address']).isRequired,

  fieldOptions: external_commonjs_prop_types_commonjs2_prop_types_amd_PropTypes_root_PropTypes_default.a.arrayOf(external_commonjs_prop_types_commonjs2_prop_types_amd_PropTypes_root_PropTypes_default.a.shape({
    label: external_commonjs_prop_types_commonjs2_prop_types_amd_PropTypes_root_PropTypes_default.a.string,
    value: external_commonjs_prop_types_commonjs2_prop_types_amd_PropTypes_root_PropTypes_default.a.oneOfType([external_commonjs_prop_types_commonjs2_prop_types_amd_PropTypes_root_PropTypes_default.a.string, external_commonjs_prop_types_commonjs2_prop_types_amd_PropTypes_root_PropTypes_default.a.number, external_commonjs_prop_types_commonjs2_prop_types_amd_PropTypes_root_PropTypes_default.a.bool])
  }))
})));
// CONCATENATED MODULE: ./src/providers/DefaultProvider.js
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

// -----------------------------------------------------
// Defintion
// -----------------------------------------------------

var DefaultProvider = function () {
  function DefaultProvider() {
    _classCallCheck(this, DefaultProvider);

    this.adapter = {
      matcher: function matcher() {
        return true;
      },
      transformIn: function transformIn(data) {
        return data;
      },
      transformOut: function transformOut(data) {
        return data;
      },
      create: function create() {
        return {};
      },
      node: null,
      name: null,
      providesControl: false
    };
  }

  _createClass(DefaultProvider, [{
    key: "getAdapter",
    value: function getAdapter() {
      return this.adapter;
    }
  }]);

  return DefaultProvider;
}();

// -----------------------------------------------------
// Convenience
// -----------------------------------------------------

var defaultAdapter = new DefaultProvider().getAdapter();

// -----------------------------------------------------
// Exports
// -----------------------------------------------------



/* harmony default export */ var providers_DefaultProvider = (DefaultProvider);
// CONCATENATED MODULE: ./src/providers/Registry.js
var Registry_createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function Registry_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }



// --------------------------------------------------------
// Class Definition
// --------------------------------------------------------

var Registry_Registry = function () {

  // initialisation
  function Registry() {
    Registry_classCallCheck(this, Registry);

    this.adapters = new Set();
  }

  // add new adapter


  Registry_createClass(Registry, [{
    key: 'add',
    value: function add(adapter) {
      this.adapters.add(adapter);
      return adapter;
    }

    // match condition structure against registered adapters
    // and return first hit; if no matches, return a default
    // noop adapter

  }, {
    key: 'find',
    value: function find(data) {
      var matchedAdapter = Array.from(this.adapters).find(function (_ref) {
        var matcher = _ref.matcher;
        return matcher(data);
      });

      return matchedAdapter || defaultAdapter;
    }

    // return key information about each registered
    // provider object

  }, {
    key: 'getCreators',
    value: function getCreators() {
      return Array.from(this.adapters).map(function (_ref2) {
        var create = _ref2.create,
            name = _ref2.name,
            providesControl = _ref2.providesControl;
        return { create: create, name: name, providesControl: providesControl };
      });
    }
  }]);

  return Registry;
}();

// --------------------------------------------------------
// Exports
// --------------------------------------------------------

/* harmony default export */ var providers_Registry = (Registry_Registry);
// CONCATENATED MODULE: ./src/utils/rebind.js
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

/* harmony default export */ var rebind = (function () {
  var names = Array.from(arguments);

  var _names$splice = names.splice(-1, 1),
      _names$splice2 = _slicedToArray(_names$splice, 1),
      object = _names$splice2[0];

  names.forEach(function (name) {
    object[name] = object[name].bind(object);
  });
});;
// CONCATENATED MODULE: ./src/components/ConditionGroup/ProviderButtons.js
var ProviderButtons_createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function ProviderButtons_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








// -----------------------------------------------------
// Component Definition
// -----------------------------------------------------

var ProviderButtons_ProviderButtons = function (_Component) {
  _inherits(ProviderButtons, _Component);

  function ProviderButtons(props) {
    ProviderButtons_classCallCheck(this, ProviderButtons);

    var _this = _possibleConstructorReturn(this, (ProviderButtons.__proto__ || Object.getPrototypeOf(ProviderButtons)).call(this, props));

    _this.creators = props.registry.getCreators();

    rebind('handleClick', _this);
    return _this;
  }

  ProviderButtons_createClass(ProviderButtons, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      return this.creators.filter(function (_ref) {
        var providesControl = _ref.providesControl;
        return providesControl;
      }).map(function (_ref2, i) {
        var create = _ref2.create,
            name = _ref2.name;
        return external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.createElement(
          'a',
          { className: 'btn',
            href: '#',
            onClick: _this2.handleClick,
            key: i,
            'data-index': i },
          'Add ' + name
        );
      });
    }
  }, {
    key: 'handleClick',
    value: function handleClick(evt) {
      evt.preventDefault();

      var target = evt.target;
      var index = target.dataset.index;
      var create = this.creators[index].create;
      var onAdd = this.props.onAdd;


      onAdd(create);
    }
  }]);

  return ProviderButtons;
}(external_commonjs_react_commonjs2_react_amd_React_root_React_["Component"]);

// -----------------------------------------------------
// PropTypes
// -----------------------------------------------------

ProviderButtons_ProviderButtons.propTypes = {
  registry: external_commonjs_prop_types_commonjs2_prop_types_amd_PropTypes_root_PropTypes_default.a.instanceOf(providers_Registry).isRequired,
  onAdd: external_commonjs_prop_types_commonjs2_prop_types_amd_PropTypes_root_PropTypes_default.a.func.isRequired

  // -----------------------------------------------------
  // Exports
  // -----------------------------------------------------

};/* harmony default export */ var ConditionGroup_ProviderButtons = (ProviderButtons_ProviderButtons);
// CONCATENATED MODULE: ./src/components/ConditionGroup/Header.js
var Header_createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function Header_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function Header_possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function Header_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }









// -----------------------------------------------------
// Component Definition
// -----------------------------------------------------

var Header_Header = function (_Component) {
  Header_inherits(Header, _Component);

  function Header(props) {
    Header_classCallCheck(this, Header);

    var _this = Header_possibleConstructorReturn(this, (Header.__proto__ || Object.getPrototypeOf(Header)).call(this, props));

    rebind("handleChange", "handleRemoveGroup", _this);
    return _this;
  }

  Header_createClass(Header, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          operations = _props.operations,
          operator = _props.operator,
          registry = _props.registry,
          onAdd = _props.onAdd;


      return external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.createElement(
        'div',
        { className: 'header' },
        external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.createElement(
          'div',
          null,
          external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.createElement(
            'select',
            { value: operator, onChange: this.handleChange },
            operations.map(function (_ref) {
              var label = _ref.label,
                  value = _ref.value;
              return external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.createElement(
                'option',
                { value: value,
                  key: value },
                label
              );
            })
          )
        ),
        external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.createElement(
          'div',
          null,
          external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.createElement(ConditionGroup_ProviderButtons, { registry: registry,
            onAdd: onAdd }),
          external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.createElement(
            'a',
            { className: 'btn', href: '#', onClick: this.handleRemoveGroup },
            '\u2014'
          )
        )
      );
    }
  }, {
    key: 'handleChange',
    value: function handleChange(_ref2) {
      var value = _ref2.target.value;
      var onChange = this.props.onChange;

      onChange(value);
    }
  }, {
    key: 'handleRemoveGroup',
    value: function handleRemoveGroup(evt) {
      evt.preventDefault();
      this.props.onRemove();
    }
  }]);

  return Header;
}(external_commonjs_react_commonjs2_react_amd_React_root_React_["Component"]);

// -----------------------------------------------------
// PropTypes
// -----------------------------------------------------

Header_Header.defaultProps = {
  operator: 'and'
};

Header_Header.propTypes = {
  operator: external_commonjs_prop_types_commonjs2_prop_types_amd_PropTypes_root_PropTypes_default.a.string,
  operations: external_commonjs_prop_types_commonjs2_prop_types_amd_PropTypes_root_PropTypes_default.a.array.isRequired,
  registry: external_commonjs_prop_types_commonjs2_prop_types_amd_PropTypes_root_PropTypes_default.a.instanceOf(providers_Registry).isRequired,
  onChange: external_commonjs_prop_types_commonjs2_prop_types_amd_PropTypes_root_PropTypes_default.a.func.isRequired,
  onAdd: external_commonjs_prop_types_commonjs2_prop_types_amd_PropTypes_root_PropTypes_default.a.func.isRequired,
  onRemove: external_commonjs_prop_types_commonjs2_prop_types_amd_PropTypes_root_PropTypes_default.a.func.isRequired
};

// -----------------------------------------------------
// Exports
// -----------------------------------------------------

/* harmony default export */ var ConditionGroup_Header = (Header_Header);
// CONCATENATED MODULE: ./src/components/ProviderNode.js
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var ProviderNode_createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function ProviderNode_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function ProviderNode_possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function ProviderNode_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








// -----------------------------------------------------
// Component Definition
// -----------------------------------------------------

var ProviderNode_ProviderNode = function (_Component) {
  ProviderNode_inherits(ProviderNode, _Component);

  function ProviderNode(props) {
    ProviderNode_classCallCheck(this, ProviderNode);

    var _this = ProviderNode_possibleConstructorReturn(this, (ProviderNode.__proto__ || Object.getPrototypeOf(ProviderNode)).call(this, props));

    var condition = props.condition,
        registry = props.registry;

    _this.adapter = registry.find(condition);

    rebind('handleChange', _this);
    return _this;
  }

  ProviderNode_createClass(ProviderNode, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          condition = _props.condition,
          fields = _props.fields,
          registry = _props.registry,
          forwardProps = _objectWithoutProperties(_props, ['condition', 'fields', 'registry']);

      var _adapter = this.adapter,
          transformIn = _adapter.transformIn,
          Node = _adapter.node;


      if (Node) {
        return external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.createElement(Node, _extends({}, forwardProps, {
          condition: transformIn(condition, fields),
          fields: fields,
          registry: registry,
          onChange: this.handleChange }));
      } else {
        return null;
      }
    }
  }, {
    key: 'handleChange',
    value: function handleChange(condition, index) {
      var _props2 = this.props,
          onChange = _props2.onChange,
          fields = _props2.fields;
      var transformOut = this.adapter.transformOut;


      onChange(transformOut(condition, fields), index);
    }
  }]);

  return ProviderNode;
}(external_commonjs_react_commonjs2_react_amd_React_root_React_["Component"]);

// -----------------------------------------------------
// PropTypes
// -----------------------------------------------------

ProviderNode_ProviderNode.propTypes = {
  condition: external_commonjs_prop_types_commonjs2_prop_types_amd_PropTypes_root_PropTypes_default.a.object,
  fields: propTypes_fields.isRequired,
  registry: external_commonjs_prop_types_commonjs2_prop_types_amd_PropTypes_root_PropTypes_default.a.instanceOf(providers_Registry).isRequired,
  onChange: external_commonjs_prop_types_commonjs2_prop_types_amd_PropTypes_root_PropTypes_default.a.func.isRequired

  // -----------------------------------------------------
  // Exports
  // -----------------------------------------------------

};/* harmony default export */ var components_ProviderNode = (ProviderNode_ProviderNode);
// CONCATENATED MODULE: ./src/components/ConditionGroup/Items.js
var Items_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var Items_createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function Items_objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function Items_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function Items_possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function Items_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }










// -----------------------------------------------------
// Component Definition
// -----------------------------------------------------

var Items_Items = function (_Component) {
  Items_inherits(Items, _Component);

  function Items(props) {
    Items_classCallCheck(this, Items);

    var _this = Items_possibleConstructorReturn(this, (Items.__proto__ || Object.getPrototypeOf(Items)).call(this, props));

    rebind("handleChange", "handleRemove", _this);
    return _this;
  }

  Items_createClass(Items, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          condition = _props.condition,
          fields = _props.fields,
          registry = _props.registry,
          forwardProps = Items_objectWithoutProperties(_props, ['condition', 'fields', 'registry']);

      return condition.map(function (cond, i) {
        return external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.createElement(components_ProviderNode, Items_extends({}, forwardProps, {
          condition: cond,
          fields: fields,
          registry: registry,
          key: i,
          index: i,
          onChange: _this2.handleChange,
          onRemove: _this2.handleRemove }));
      });
    }
  }, {
    key: 'handleChange',
    value: function handleChange(cond, index) {
      var _props2 = this.props,
          onChange = _props2.onChange,
          condition = _props2.condition;


      var nextCondition = [].concat(_toConsumableArray(condition));
      nextCondition[index] = cond;

      onChange(nextCondition);
    }
  }, {
    key: 'handleRemove',
    value: function handleRemove(index) {
      var _props3 = this.props,
          onChange = _props3.onChange,
          condition = _props3.condition;


      var nextCondition = [].concat(_toConsumableArray(condition));
      nextCondition.splice(index, 1);

      onChange(nextCondition);
    }
  }]);

  return Items;
}(external_commonjs_react_commonjs2_react_amd_React_root_React_["Component"]);

;

// -----------------------------------------------------
// PropTypes
// -----------------------------------------------------

Items_Items.propTypes = {
  condition: external_commonjs_prop_types_commonjs2_prop_types_amd_PropTypes_root_PropTypes_default.a.array.isRequired,
  fields: propTypes_fields.isRequired,
  registry: external_commonjs_prop_types_commonjs2_prop_types_amd_PropTypes_root_PropTypes_default.a.instanceOf(providers_Registry).isRequired,
  onChange: external_commonjs_prop_types_commonjs2_prop_types_amd_PropTypes_root_PropTypes_default.a.func.isRequired
};

// -----------------------------------------------------
// Exports
// -----------------------------------------------------

/* harmony default export */ var ConditionGroup_Items = (Items_Items);
// EXTERNAL MODULE: ./src/style/ConditionGroup.css
var style_ConditionGroup = __webpack_require__(3);

// CONCATENATED MODULE: ./src/components/ConditionGroup/index.js
var ConditionGroup_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var ConditionGroup_createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function ConditionGroup_objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function ConditionGroup_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function ConditionGroup_possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function ConditionGroup_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function ConditionGroup_toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }













// -----------------------------------------------------
// Helpers
// -----------------------------------------------------

var defaultOperator = 'and';

var ConditionGroup_operations = [{ label: 'All', value: 'and' }, { label: 'Any', value: 'or' }];

var getItems = function getItems(condition) {
  var and = condition.and,
      or = condition.or,
      conditions = condition.conditions;

  return and || or || conditions && getItems(conditions) || [];
};

var getOperator = function getOperator(condition) {
  var and = condition.and,
      or = condition.or,
      conditions = condition.conditions;


  return and && 'and' || or && 'or' || conditions && getOperator(conditions) || defaultOperator;
};

var getNextCondition = function getNextCondition(operator, items, scope) {
  var condition = _defineProperty({}, operator, [].concat(ConditionGroup_toConsumableArray(items)));

  if (scope) {
    return { scope: scope, condition: condition };
  }

  return condition;
};

// -----------------------------------------------------
// Component Definition
// -----------------------------------------------------

var ConditionGroup_ConditionGroup = function (_Component) {
  ConditionGroup_inherits(ConditionGroup, _Component);

  function ConditionGroup(props) {
    ConditionGroup_classCallCheck(this, ConditionGroup);

    var _this = ConditionGroup_possibleConstructorReturn(this, (ConditionGroup.__proto__ || Object.getPrototypeOf(ConditionGroup)).call(this, props));

    rebind("handleHeaderChange", "handleItemsChange", "handleAdd", "handleRemoveGroup", _this);
    return _this;
  }

  ConditionGroup_createClass(ConditionGroup, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          condition = _props.condition,
          fields = _props.fields,
          registry = _props.registry,
          forwardProps = ConditionGroup_objectWithoutProperties(_props, ['condition', 'fields', 'registry']);

      var items = getItems(condition);
      var operator = getOperator(condition);

      return external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.createElement(
        'div',
        { className: 'condition-group' },
        external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.createElement(ConditionGroup_Header, { operations: ConditionGroup_operations,
          operator: operator,
          registry: registry,
          onChange: this.handleHeaderChange,
          onAdd: this.handleAdd,
          onRemove: this.handleRemoveGroup }),
        external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.createElement(ConditionGroup_Items, ConditionGroup_extends({}, forwardProps, {
          condition: items,
          fields: fields,
          registry: registry,
          onChange: this.handleItemsChange }))
      );
    }
  }, {
    key: 'handleHeaderChange',
    value: function handleHeaderChange(operator) {
      var _props2 = this.props,
          condition = _props2.condition,
          onChange = _props2.onChange,
          index = _props2.index;
      var scope = condition.scope;

      var items = getItems(condition);
      var nextCondition = getNextCondition(operator, items, scope);

      onChange(nextCondition, index);
    }
  }, {
    key: 'handleItemsChange',
    value: function handleItemsChange(items) {
      var _props3 = this.props,
          condition = _props3.condition,
          onChange = _props3.onChange,
          index = _props3.index;
      var scope = condition.scope;

      var operator = getOperator(condition);
      var nextCondition = getNextCondition(operator, items, scope);

      onChange(nextCondition, index);
    }
  }, {
    key: 'handleAdd',
    value: function handleAdd(create) {
      var _props4 = this.props,
          condition = _props4.condition,
          onChange = _props4.onChange,
          index = _props4.index;
      var scope = condition.scope;

      var operator = getOperator(condition);
      var items = getItems(condition);
      var newItem = create();
      var nextItems = [].concat(ConditionGroup_toConsumableArray(items), [newItem]);
      var nextCondition = getNextCondition(operator, nextItems, scope);

      onChange(nextCondition, index);
    }
  }, {
    key: 'handleRemoveGroup',
    value: function handleRemoveGroup() {
      var _props5 = this.props,
          onRemove = _props5.onRemove,
          index = _props5.index;

      onRemove(index);
    }
  }]);

  return ConditionGroup;
}(external_commonjs_react_commonjs2_react_amd_React_root_React_["Component"]);

;

// -----------------------------------------------------
// PropTypes
// -----------------------------------------------------

ConditionGroup_ConditionGroup.defaultProps = {
  condition: {},
  onRemove: function onRemove() {}
};

ConditionGroup_ConditionGroup.propTypes = {
  condition: external_commonjs_prop_types_commonjs2_prop_types_amd_PropTypes_root_PropTypes_default.a.object,
  fields: propTypes_fields.isRequired,
  registry: external_commonjs_prop_types_commonjs2_prop_types_amd_PropTypes_root_PropTypes_default.a.instanceOf(providers_Registry).isRequired,
  onChange: external_commonjs_prop_types_commonjs2_prop_types_amd_PropTypes_root_PropTypes_default.a.func.isRequired,
  onRemove: external_commonjs_prop_types_commonjs2_prop_types_amd_PropTypes_root_PropTypes_default.a.func
};

// -----------------------------------------------------
// Exports
// -----------------------------------------------------

/* harmony default export */ var components_ConditionGroup = (ConditionGroup_ConditionGroup);
// CONCATENATED MODULE: ./src/components/FieldNameInput.js




// -----------------------------------------------------
// Component Definition
// -----------------------------------------------------

var FieldNameInput_FieldNameInput = function FieldNameInput(_ref) {
  var name = _ref.name,
      value = _ref.value,
      fields = _ref.fields,
      onChange = _ref.onChange,
      Control = _ref.fieldsControl;


  return external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.createElement(Control, { value: value,
    name: name,
    options: fields,
    includeBlankOption: true,
    onChange: onChange });
};

// -----------------------------------------------------
// PropTypes
// -----------------------------------------------------

FieldNameInput_FieldNameInput.defaultProps = {
  value: ''
};

FieldNameInput_FieldNameInput.propTypes = {
  fieldsControl: external_commonjs_prop_types_commonjs2_prop_types_amd_PropTypes_root_PropTypes_default.a.oneOfType([external_commonjs_prop_types_commonjs2_prop_types_amd_PropTypes_root_PropTypes_default.a.func, external_commonjs_prop_types_commonjs2_prop_types_amd_PropTypes_root_PropTypes_default.a.instanceOf(external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.Component)]).isRequired,

  value: external_commonjs_prop_types_commonjs2_prop_types_amd_PropTypes_root_PropTypes_default.a.oneOfType([external_commonjs_prop_types_commonjs2_prop_types_amd_PropTypes_root_PropTypes_default.a.string, external_commonjs_prop_types_commonjs2_prop_types_amd_PropTypes_root_PropTypes_default.a.number, external_commonjs_prop_types_commonjs2_prop_types_amd_PropTypes_root_PropTypes_default.a.bool]),
  fields: propTypes_fields.isRequired,
  name: external_commonjs_prop_types_commonjs2_prop_types_amd_PropTypes_root_PropTypes_default.a.string.isRequired,
  onChange: external_commonjs_prop_types_commonjs2_prop_types_amd_PropTypes_root_PropTypes_default.a.func.isRequired
};

// -----------------------------------------------------
// Exports
// -----------------------------------------------------

/* harmony default export */ var components_FieldNameInput = (FieldNameInput_FieldNameInput);
// CONCATENATED MODULE: ./src/constants/typeOperators.js
// -----------------------------------------------------
// Constants
// -----------------------------------------------------

var operators = {
  'string_array': ["EQ", "NEQ", "IN", "NIN", "CONTAINS", "NCONTAINS", "EMPTY", "NEMPTY"],
  'string': ["EQ", "NEQ", "IN", "NIN", "BWITH", "EWITH", "CONTAINS", "NCONTAINS", "EMPTY", "NEMPTY"],
  'datetime': ["EQ", "NEQ", "IN", "NIN", "LT", "LTE", "GT", "GTE", "EMPTY", "NEMPTY", "RANGE", "NRANGE", "DOW", "NDOW"],
  'time': ["EQ", "NEQ", "LT", "LTE", "GT", "GTE", "EMPTY", "NEMPTY"],
  'numeric_array': ["EQ", "NEQ", "IN", "NIN", "CONTAINS", "NCONTAINS", "EMPTY", "NEMPTY"],
  'numeric': ["EQ", "NEQ", "IN", "NIN", "LT", "LTE", "GT", "GTE", "EMPTY", "NEMPTY"],
  'boolean_array': ["EQ", "NEQ", "IN", "NIN", "CONTAINS", "NCONTAINS", "EMPTY", "NEMPTY"],
  'boolean': ["TRUE", "FALSE"],
  'id': ["EQ", "NEQ", "IN", "NIN", "EMPTY", "NEMPTY"],
  'file': ["EMPTY", "NEMPTY"],
  'signature': ["EMPTY", "NEMPTY"],
  'any': ["EQ", "NEQ", "IN", "NIN", "LT", "LTE", "GT", "GTE", "BWITH", "EWITH", "CONTAINS", "NCONTAINS", "EMPTY", "NEMPTY"]
};

var labels = {
  EQ: 'Equal To',
  NEQ: 'Not Equal To',
  IN: 'In',
  NIN: 'Not In',
  LT: 'Less Than',
  LTE: 'Less Than or Equal To',
  GT: 'Greater Than',
  GTE: 'Greater Than or Equal To',
  BWITH: 'Begins With',
  EWITH: 'Ends With',
  CONTAINS: 'Contains',
  NCONTAINS: 'Does Not Contain',
  EMPTY: 'Is Empty',
  NEMPTY: 'Is Not Empty',
  TRUE: 'Is True',
  FALSE: 'Is False',
  RANGE: 'Is In Date Range',
  NRANGE: 'Is Not In Date Range',
  DOW: 'Is Day Of The Week',
  NDOW: 'Is Not Day Of The Week'
};

var typeOperators = Object.keys(operators).reduce(function (result, type) {
  result[type] = operators[type].map(function (op) {
    return {
      value: op,
      label: labels[op]
    };
  });
  return result;
}, {});

var valuelessTypeOperators = ['EMPTY', 'NEMPTY', 'TRUE', 'FALSE'];
var freeformTypeOperators = ['BWITH', 'EWITH', 'CONTAINS', 'NCONTAINS'];
var dateRangeOperators = ['RANGE', 'NRANGE'];
var dateDowOperators = ['DOW', 'NDOW'];

// -----------------------------------------------------
// Exports
// -----------------------------------------------------


/* harmony default export */ var constants_typeOperators = (typeOperators);
// CONCATENATED MODULE: ./src/utils/indexOn.js
/* harmony default export */ var indexOn = (function (collection, property) {
  return collection.reduce(function (acc, entry) {
    var key = entry[property];
    acc[key] = entry;
    return acc;
  }, {});
});;
// CONCATENATED MODULE: ./src/components/OperatorInput.js







// -----------------------------------------------------
// Helpers
// -----------------------------------------------------

var optionsFromCondition = function optionsFromCondition(condition, fields, operators) {
  var value = condition.field_name;
  var field = fields[value] || {};
  var _field$dataType = field.dataType,
      dataType = _field$dataType === undefined ? 'string' : _field$dataType;


  return operators[dataType] || [];
};

// -----------------------------------------------------
// Component Definition
// -----------------------------------------------------

var OperatorInput_OperatorInput = function OperatorInput(_ref) {
  var condition = _ref.condition,
      name = _ref.name,
      fields = _ref.fields,
      onChange = _ref.onChange,
      Control = _ref.opsControl;

  var indexedFields = indexOn(fields, 'value');
  var options = optionsFromCondition(condition, indexedFields, constants_typeOperators);
  var op = condition.op;


  return external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.createElement(Control, { name: name,
    value: op,
    onChange: onChange,
    includeBlankOption: true,
    options: options });
};

// -----------------------------------------------------
// PropTypes
// -----------------------------------------------------

OperatorInput_OperatorInput.defaultProps = {};

OperatorInput_OperatorInput.propTypes = {
  opsControl: external_commonjs_prop_types_commonjs2_prop_types_amd_PropTypes_root_PropTypes_default.a.oneOfType([external_commonjs_prop_types_commonjs2_prop_types_amd_PropTypes_root_PropTypes_default.a.func, external_commonjs_prop_types_commonjs2_prop_types_amd_PropTypes_root_PropTypes_default.a.instanceOf(external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.Component)]).isRequired,

  condition: external_commonjs_prop_types_commonjs2_prop_types_amd_PropTypes_root_PropTypes_default.a.shape({
    field_name: external_commonjs_prop_types_commonjs2_prop_types_amd_PropTypes_root_PropTypes_default.a.node,
    op: external_commonjs_prop_types_commonjs2_prop_types_amd_PropTypes_root_PropTypes_default.a.string,
    value: external_commonjs_prop_types_commonjs2_prop_types_amd_PropTypes_root_PropTypes_default.a.oneOfType([external_commonjs_prop_types_commonjs2_prop_types_amd_PropTypes_root_PropTypes_default.a.string, external_commonjs_prop_types_commonjs2_prop_types_amd_PropTypes_root_PropTypes_default.a.number, external_commonjs_prop_types_commonjs2_prop_types_amd_PropTypes_root_PropTypes_default.a.bool, external_commonjs_prop_types_commonjs2_prop_types_amd_PropTypes_root_PropTypes_default.a.array])
  }).isRequired,

  fields: propTypes_fields.isRequired,
  name: external_commonjs_prop_types_commonjs2_prop_types_amd_PropTypes_root_PropTypes_default.a.string.isRequired,
  onChange: external_commonjs_prop_types_commonjs2_prop_types_amd_PropTypes_root_PropTypes_default.a.func.isRequired
};

// -----------------------------------------------------
// Exports
// -----------------------------------------------------

/* harmony default export */ var components_OperatorInput = (OperatorInput_OperatorInput);
// CONCATENATED MODULE: ./src/utils/cast.js
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

// -----------------------------------------------------
// Helpers
// -----------------------------------------------------

var falseValues = [false, 0, "0", "f", "F", "false", "FALSE", "no", "NO"];

var defaultType = 'string';

var casters = {
  'string': function string(value) {
    return value !== null && value !== undefined ? (typeof value === "undefined" ? "undefined" : _typeof(value)) === 'object' ? value : value.toString() : '';
  },
  'numeric': function numeric(value) {
    return (typeof value === "undefined" ? "undefined" : _typeof(value)) === 'object' ? value : +value;
  },
  'boolean': function boolean(value) {
    return !falseValues.includes(value);
  },
  'date': function date(value) {
    return new Date(value);
  },
  'string_array': function string_array(value) {
    return [].concat(value).map(function (v) {
      return casters.string(v);
    });
  },
  'numeric_array': function numeric_array(value) {
    return [].concat(value).map(function (v) {
      return casters.numeric(v);
    });
  },
  'boolean_array': function boolean_array(value) {
    return [].concat(value).map(function (v) {
      return casters.boolean(v);
    });
  }
};

// -----------------------------------------------------
// Exports
// -----------------------------------------------------

function cast(value, type) {
  var castFn = casters[type] || casters[defaultType];
  return castFn(value);
}
// CONCATENATED MODULE: ./src/components/ValueInput.js
var ValueInput_createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function ValueInput_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function ValueInput_possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function ValueInput_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }










var formFieldExpr = /^(field|calculation)_(\d+)_(\d+)$/;

// -----------------------------------------------------
// Helpers
// -----------------------------------------------------

var defaultFieldType = 'text';
var defaultDataType = 'string';

var fieldTypeFromCondition = function fieldTypeFromCondition(condition, fields) {
  var value = condition.field_name;
  var field = fields[value] || {};
  return field.fieldType || defaultFieldType;
};

var dataTypeFromCondition = function dataTypeFromCondition(condition, fields) {
  var value = condition.field_name;
  var field = fields[value] || {};
  return field.dataType || defaultDataType;
};

var ValueInput_optionsFromCondition = function optionsFromCondition(condition, fields) {
  var value = condition.field_name;
  var field = fields[value] || {};
  var options = field.fieldOptions || [];

  if (field.fieldType === 'number') {
    return optionsFromFields(fields, field.fieldType);
  } else if (field.fieldType === 'date') {
    return optionsFromDateOptions(options, fields, condition);
  } else {
    return options;
  }
};

var optionsFromFields = function optionsFromFields(fields, type) {
  return Object.values(fields).filter(function (_ref) {
    var value = _ref.value,
        fieldType = _ref.fieldType;
    return formFieldExpr.test(value) && fieldType === type;
  });
};

var optionsFromDateOptions = function optionsFromDateOptions(options, fields, condition) {
  var opFilter = ValueInput_dateOptionsFilter(condition);

  if (opFilter) {
    return options.filter(function (_ref2) {
      var op = _ref2.op;
      return op === opFilter;
    });
  } else {
    return optionsFromFields(fields, 'date');
  }
};

var ValueInput_dateOptionsFilter = function dateOptionsFilter(_ref3) {
  var op = _ref3.op;

  if (dateRangeOperators.includes(op)) {
    return dateRangeOperators[0].toLowerCase();
  } else if (dateDowOperators.includes(op)) {
    return dateDowOperators[0].toLowerCase();
  } else {
    return null;
  }
};

var defaultControlProp = 'valuesTextControl';

var controlPropsByFieldType = {
  number: 'valuesNumberControl',
  email: 'valuesEmailControl',
  text: 'valuesTextControl',
  date: 'valuesDateControl',
  time: 'valuesTimeControl',
  selectOne: 'valuesSelectOneControl',
  selectMany: 'valuesSelectManyControl'
};

var ValueInput_controlPropFromTypeAndOp = function controlPropFromTypeAndOp(type, op) {
  if ((type === 'selectOne' || type === 'selectMany') && freeformTypeOperators.includes(op)) {
    return defaultControlProp;
  } else if (type === 'date' && (dateRangeOperators.includes(op) || dateDowOperators.includes(op))) {
    return controlPropsByFieldType['selectOne'];
  }

  return controlPropsByFieldType[type] || defaultControlProp;
};

// -----------------------------------------------------
// Component Definition
// -----------------------------------------------------

var ValueInput_ValueInput = function (_Component) {
  ValueInput_inherits(ValueInput, _Component);

  function ValueInput(props) {
    ValueInput_classCallCheck(this, ValueInput);

    var _this = ValueInput_possibleConstructorReturn(this, (ValueInput.__proto__ || Object.getPrototypeOf(ValueInput)).call(this, props));

    rebind('handleChange', 'handleChangeMultiple', _this);
    return _this;
  }

  ValueInput_createClass(ValueInput, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          name = _props.name,
          condition = _props.condition,
          fields = _props.fields;

      var indexedFields = indexOn(fields, 'value');

      var type = fieldTypeFromCondition(condition, indexedFields);
      var options = ValueInput_optionsFromCondition(condition, indexedFields);
      var value = condition.value,
          op = condition.op;


      var controlProp = ValueInput_controlPropFromTypeAndOp(type, op);
      var Control = this.props[controlProp];

      var multiValue = type === 'selectMany';
      // const changeHandler = multiValue
      //                       ? this.handleChangeMultiple
      //                       : this.handleChange;

      return external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.createElement(Control, { name: name,
        value: value,
        options: options,
        multiple: multiValue,
        onChange: this.handleChange });
    }
  }, {
    key: 'handleChange',
    value: function handleChange(_ref4) {
      var _ref4$target = _ref4.target,
          name = _ref4$target.name,
          value = _ref4$target.value;
      var _props2 = this.props,
          condition = _props2.condition,
          fields = _props2.fields,
          onChange = _props2.onChange;


      var indexedFields = indexOn(fields, 'value');
      var dataType = dataTypeFromCondition(condition, indexedFields);
      var castValue = cast(value, dataType);

      onChange({ target: { name: name, value: castValue } });
    }
  }, {
    key: 'handleChangeMultiple',
    value: function handleChangeMultiple(_ref5) {
      var _ref5$target = _ref5.target,
          name = _ref5$target.name,
          options = _ref5$target.options;
      var _props3 = this.props,
          condition = _props3.condition,
          fields = _props3.fields,
          onChange = _props3.onChange;

      var indexedFields = indexOn(fields, 'value');

      var value = Array.from(options).filter(function (_ref6) {
        var selected = _ref6.selected;
        return selected;
      }).map(function (_ref7) {
        var value = _ref7.value;
        return value;
      });

      var dataType = dataTypeFromCondition(condition, indexedFields);
      var castValue = cast(value, dataType);

      onChange({ target: { name: name, value: castValue } });
    }
  }]);

  return ValueInput;
}(external_commonjs_react_commonjs2_react_amd_React_root_React_["Component"]);

;

// -----------------------------------------------------
// PropTypes
// -----------------------------------------------------

ValueInput_ValueInput.propTypes = {
  valuesDateControl: external_commonjs_prop_types_commonjs2_prop_types_amd_PropTypes_root_PropTypes_default.a.oneOfType([external_commonjs_prop_types_commonjs2_prop_types_amd_PropTypes_root_PropTypes_default.a.func, external_commonjs_prop_types_commonjs2_prop_types_amd_PropTypes_root_PropTypes_default.a.instanceOf(external_commonjs_react_commonjs2_react_amd_React_root_React_["Component"])]).isRequired,

  valuesTimeControl: external_commonjs_prop_types_commonjs2_prop_types_amd_PropTypes_root_PropTypes_default.a.oneOfType([external_commonjs_prop_types_commonjs2_prop_types_amd_PropTypes_root_PropTypes_default.a.func, external_commonjs_prop_types_commonjs2_prop_types_amd_PropTypes_root_PropTypes_default.a.instanceOf(external_commonjs_react_commonjs2_react_amd_React_root_React_["Component"])]).isRequired,

  valuesTextControl: external_commonjs_prop_types_commonjs2_prop_types_amd_PropTypes_root_PropTypes_default.a.oneOfType([external_commonjs_prop_types_commonjs2_prop_types_amd_PropTypes_root_PropTypes_default.a.func, external_commonjs_prop_types_commonjs2_prop_types_amd_PropTypes_root_PropTypes_default.a.instanceOf(external_commonjs_react_commonjs2_react_amd_React_root_React_["Component"])]).isRequired,

  valuesEmailControl: external_commonjs_prop_types_commonjs2_prop_types_amd_PropTypes_root_PropTypes_default.a.oneOfType([external_commonjs_prop_types_commonjs2_prop_types_amd_PropTypes_root_PropTypes_default.a.func, external_commonjs_prop_types_commonjs2_prop_types_amd_PropTypes_root_PropTypes_default.a.instanceOf(external_commonjs_react_commonjs2_react_amd_React_root_React_["Component"])]).isRequired,

  valuesNumberControl: external_commonjs_prop_types_commonjs2_prop_types_amd_PropTypes_root_PropTypes_default.a.oneOfType([external_commonjs_prop_types_commonjs2_prop_types_amd_PropTypes_root_PropTypes_default.a.func, external_commonjs_prop_types_commonjs2_prop_types_amd_PropTypes_root_PropTypes_default.a.instanceOf(external_commonjs_react_commonjs2_react_amd_React_root_React_["Component"])]).isRequired,

  valuesSelectOneControl: external_commonjs_prop_types_commonjs2_prop_types_amd_PropTypes_root_PropTypes_default.a.oneOfType([external_commonjs_prop_types_commonjs2_prop_types_amd_PropTypes_root_PropTypes_default.a.func, external_commonjs_prop_types_commonjs2_prop_types_amd_PropTypes_root_PropTypes_default.a.instanceOf(external_commonjs_react_commonjs2_react_amd_React_root_React_["Component"])]).isRequired,

  valuesSelectManyControl: external_commonjs_prop_types_commonjs2_prop_types_amd_PropTypes_root_PropTypes_default.a.oneOfType([external_commonjs_prop_types_commonjs2_prop_types_amd_PropTypes_root_PropTypes_default.a.func, external_commonjs_prop_types_commonjs2_prop_types_amd_PropTypes_root_PropTypes_default.a.instanceOf(external_commonjs_react_commonjs2_react_amd_React_root_React_["Component"])]).isRequired,

  condition: external_commonjs_prop_types_commonjs2_prop_types_amd_PropTypes_root_PropTypes_default.a.shape({
    field_name: external_commonjs_prop_types_commonjs2_prop_types_amd_PropTypes_root_PropTypes_default.a.node,
    op: external_commonjs_prop_types_commonjs2_prop_types_amd_PropTypes_root_PropTypes_default.a.string,
    value: external_commonjs_prop_types_commonjs2_prop_types_amd_PropTypes_root_PropTypes_default.a.oneOfType([external_commonjs_prop_types_commonjs2_prop_types_amd_PropTypes_root_PropTypes_default.a.string, external_commonjs_prop_types_commonjs2_prop_types_amd_PropTypes_root_PropTypes_default.a.number, external_commonjs_prop_types_commonjs2_prop_types_amd_PropTypes_root_PropTypes_default.a.bool, external_commonjs_prop_types_commonjs2_prop_types_amd_PropTypes_root_PropTypes_default.a.array])
  }).isRequired,

  fields: propTypes_fields.isRequired,
  onChange: external_commonjs_prop_types_commonjs2_prop_types_amd_PropTypes_root_PropTypes_default.a.func.isRequired,
  name: external_commonjs_prop_types_commonjs2_prop_types_amd_PropTypes_root_PropTypes_default.a.string.isRequired
};

// -----------------------------------------------------
// Exports
// -----------------------------------------------------

/* harmony default export */ var components_ValueInput = (ValueInput_ValueInput);
// CONCATENATED MODULE: ./src/components/Item.js
var Item_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var Item_createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function Item_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function Item_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function Item_possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function Item_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }












// -----------------------------------------------------
// Component Definition
// -----------------------------------------------------

var Item_Item = function (_Component) {
  Item_inherits(Item, _Component);

  function Item(props) {
    Item_classCallCheck(this, Item);

    var _this = Item_possibleConstructorReturn(this, (Item.__proto__ || Object.getPrototypeOf(Item)).call(this, props));

    rebind("handleChange", "handleRemove", _this);
    return _this;
  }

  Item_createClass(Item, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          condition = _props.condition,
          fields = _props.fields,
          fieldsControl = _props.fieldsControl,
          opsControl = _props.opsControl,
          valuesDateControl = _props.valuesDateControl,
          valuesTimeControl = _props.valuesTimeControl,
          valuesTextControl = _props.valuesTextControl,
          valuesEmailControl = _props.valuesEmailControl,
          valuesNumberControl = _props.valuesNumberControl,
          valuesSelectOneControl = _props.valuesSelectOneControl,
          valuesSelectManyControl = _props.valuesSelectManyControl;
      var op = condition.op,
          _condition$field_name = condition.field_name,
          field_name = _condition$field_name === undefined ? '' : _condition$field_name;

      var isValueless = valuelessTypeOperators.includes(op);

      return external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.createElement(
        'div',
        { className: 'item' },
        external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.createElement(
          'div',
          null,
          external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.createElement(components_FieldNameInput, { name: 'field_name',
            value: field_name,
            fields: fields,
            fieldsControl: fieldsControl,
            onChange: this.handleChange })
        ),
        external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.createElement(
          'div',
          null,
          external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.createElement(components_OperatorInput, { name: 'op',
            condition: condition,
            fields: fields,
            opsControl: opsControl,
            onChange: this.handleChange })
        ),
        isValueless ? external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.createElement('div', null) : external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.createElement(
          'div',
          null,
          external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.createElement(components_ValueInput, { name: 'value',
            condition: condition,
            fields: fields,
            valuesDateControl: valuesDateControl,
            valuesTimeControl: valuesTimeControl,
            valuesTextControl: valuesTextControl,
            valuesEmailControl: valuesEmailControl,
            valuesNumberControl: valuesNumberControl,
            valuesSelectOneControl: valuesSelectOneControl,
            valuesSelectManyControl: valuesSelectManyControl,
            onChange: this.handleChange })
        ),
        external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.createElement(
          'div',
          null,
          external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.createElement(
            'a',
            { className: 'btn', href: '#', onClick: this.handleRemove },
            '\u2014'
          )
        )
      );
    }
  }, {
    key: 'handleChange',
    value: function handleChange(_ref) {
      var _ref$target = _ref.target,
          name = _ref$target.name,
          value = _ref$target.value;
      var _props2 = this.props,
          onChange = _props2.onChange,
          condition = _props2.condition,
          index = _props2.index;

      onChange(Item_extends({}, condition, Item_defineProperty({}, name, value)), index);
    }
  }, {
    key: 'handleRemove',
    value: function handleRemove(evt) {
      evt.preventDefault();
      var _props3 = this.props,
          onRemove = _props3.onRemove,
          index = _props3.index;

      onRemove(index);
    }
  }]);

  return Item;
}(external_commonjs_react_commonjs2_react_amd_React_root_React_["Component"]);

// -----------------------------------------------------
// PropTypes
// -----------------------------------------------------

Item_Item.propTypes = {
  fieldsControl: external_commonjs_prop_types_commonjs2_prop_types_amd_PropTypes_root_PropTypes_default.a.oneOfType([external_commonjs_prop_types_commonjs2_prop_types_amd_PropTypes_root_PropTypes_default.a.func, external_commonjs_prop_types_commonjs2_prop_types_amd_PropTypes_root_PropTypes_default.a.instanceOf(external_commonjs_react_commonjs2_react_amd_React_root_React_["Component"])]),
  opsControl: external_commonjs_prop_types_commonjs2_prop_types_amd_PropTypes_root_PropTypes_default.a.oneOfType([external_commonjs_prop_types_commonjs2_prop_types_amd_PropTypes_root_PropTypes_default.a.func, external_commonjs_prop_types_commonjs2_prop_types_amd_PropTypes_root_PropTypes_default.a.instanceOf(external_commonjs_react_commonjs2_react_amd_React_root_React_["Component"])]),
  valuesDateControl: external_commonjs_prop_types_commonjs2_prop_types_amd_PropTypes_root_PropTypes_default.a.oneOfType([external_commonjs_prop_types_commonjs2_prop_types_amd_PropTypes_root_PropTypes_default.a.func, external_commonjs_prop_types_commonjs2_prop_types_amd_PropTypes_root_PropTypes_default.a.instanceOf(external_commonjs_react_commonjs2_react_amd_React_root_React_["Component"])]),
  valuesTimeControl: external_commonjs_prop_types_commonjs2_prop_types_amd_PropTypes_root_PropTypes_default.a.oneOfType([external_commonjs_prop_types_commonjs2_prop_types_amd_PropTypes_root_PropTypes_default.a.func, external_commonjs_prop_types_commonjs2_prop_types_amd_PropTypes_root_PropTypes_default.a.instanceOf(external_commonjs_react_commonjs2_react_amd_React_root_React_["Component"])]),
  valuesTextControl: external_commonjs_prop_types_commonjs2_prop_types_amd_PropTypes_root_PropTypes_default.a.oneOfType([external_commonjs_prop_types_commonjs2_prop_types_amd_PropTypes_root_PropTypes_default.a.func, external_commonjs_prop_types_commonjs2_prop_types_amd_PropTypes_root_PropTypes_default.a.instanceOf(external_commonjs_react_commonjs2_react_amd_React_root_React_["Component"])]),
  valuesEmailControl: external_commonjs_prop_types_commonjs2_prop_types_amd_PropTypes_root_PropTypes_default.a.oneOfType([external_commonjs_prop_types_commonjs2_prop_types_amd_PropTypes_root_PropTypes_default.a.func, external_commonjs_prop_types_commonjs2_prop_types_amd_PropTypes_root_PropTypes_default.a.instanceOf(external_commonjs_react_commonjs2_react_amd_React_root_React_["Component"])]),
  valuesNumberControl: external_commonjs_prop_types_commonjs2_prop_types_amd_PropTypes_root_PropTypes_default.a.oneOfType([external_commonjs_prop_types_commonjs2_prop_types_amd_PropTypes_root_PropTypes_default.a.func, external_commonjs_prop_types_commonjs2_prop_types_amd_PropTypes_root_PropTypes_default.a.instanceOf(external_commonjs_react_commonjs2_react_amd_React_root_React_["Component"])]),
  valuesSelectOneControl: external_commonjs_prop_types_commonjs2_prop_types_amd_PropTypes_root_PropTypes_default.a.oneOfType([external_commonjs_prop_types_commonjs2_prop_types_amd_PropTypes_root_PropTypes_default.a.func, external_commonjs_prop_types_commonjs2_prop_types_amd_PropTypes_root_PropTypes_default.a.instanceOf(external_commonjs_react_commonjs2_react_amd_React_root_React_["Component"])]),
  valuesSelectManyControl: external_commonjs_prop_types_commonjs2_prop_types_amd_PropTypes_root_PropTypes_default.a.oneOfType([external_commonjs_prop_types_commonjs2_prop_types_amd_PropTypes_root_PropTypes_default.a.func, external_commonjs_prop_types_commonjs2_prop_types_amd_PropTypes_root_PropTypes_default.a.instanceOf(external_commonjs_react_commonjs2_react_amd_React_root_React_["Component"])]),

  condition: external_commonjs_prop_types_commonjs2_prop_types_amd_PropTypes_root_PropTypes_default.a.shape({
    field_name: external_commonjs_prop_types_commonjs2_prop_types_amd_PropTypes_root_PropTypes_default.a.node,
    op: external_commonjs_prop_types_commonjs2_prop_types_amd_PropTypes_root_PropTypes_default.a.string,
    value: external_commonjs_prop_types_commonjs2_prop_types_amd_PropTypes_root_PropTypes_default.a.oneOfType([external_commonjs_prop_types_commonjs2_prop_types_amd_PropTypes_root_PropTypes_default.a.string, external_commonjs_prop_types_commonjs2_prop_types_amd_PropTypes_root_PropTypes_default.a.number, external_commonjs_prop_types_commonjs2_prop_types_amd_PropTypes_root_PropTypes_default.a.bool, external_commonjs_prop_types_commonjs2_prop_types_amd_PropTypes_root_PropTypes_default.a.array])
  }).isRequired,

  fields: propTypes_fields.isRequired,
  index: external_commonjs_prop_types_commonjs2_prop_types_amd_PropTypes_root_PropTypes_default.a.number,
  onChange: external_commonjs_prop_types_commonjs2_prop_types_amd_PropTypes_root_PropTypes_default.a.func.isRequired,
  onRemove: external_commonjs_prop_types_commonjs2_prop_types_amd_PropTypes_root_PropTypes_default.a.func.isRequired
};

// -----------------------------------------------------
// Exports
// -----------------------------------------------------

/* harmony default export */ var components_Item = (Item_Item);
// EXTERNAL MODULE: external {"commonjs":"ajv","commonjs2":"ajv","amd":"Ajv","root":"Ajv"}
var external_commonjs_ajv_commonjs2_ajv_amd_Ajv_root_Ajv_ = __webpack_require__(2);
var external_commonjs_ajv_commonjs2_ajv_amd_Ajv_root_Ajv_default = /*#__PURE__*/__webpack_require__.n(external_commonjs_ajv_commonjs2_ajv_amd_Ajv_root_Ajv_);

// CONCATENATED MODULE: ./src/providers/GroupProvider.js
var GroupProvider_createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function GroupProvider_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }



// -----------------------------------------------------
// Helpers
// -----------------------------------------------------

var matcher = new external_commonjs_ajv_commonjs2_ajv_amd_Ajv_root_Ajv_default.a().compile({
  type: 'object',
  oneOf: [{
    required: ['and'],
    properties: {
      and: { type: 'array' }
    }
  }, {
    required: ['or'],
    properties: {
      or: { type: 'array' }
    }
  }]
});

// -----------------------------------------------------
// Class Definition
// -----------------------------------------------------

var GroupProvider = function () {
  function GroupProvider(node, name) {
    var providesControl = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

    GroupProvider_classCallCheck(this, GroupProvider);

    this.adapter = {
      matcher: matcher,
      transformIn: function transformIn(data) {
        return data;
      },
      transformOut: function transformOut(data) {
        return data;
      },
      create: function create() {
        return { and: [] };
      },
      node: node,
      name: name,
      providesControl: providesControl
    };
  }

  GroupProvider_createClass(GroupProvider, [{
    key: 'getAdapter',
    value: function getAdapter() {
      return this.adapter;
    }
  }]);

  return GroupProvider;
}();

// -----------------------------------------------------
// Exports
// -----------------------------------------------------

/* harmony default export */ var providers_GroupProvider = (GroupProvider);
// CONCATENATED MODULE: ./src/providers/ItemProvider.js
var ItemProvider_createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function ItemProvider_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }



// -----------------------------------------------------
// Helpers
// -----------------------------------------------------

var ItemProvider_matcher = new external_commonjs_ajv_commonjs2_ajv_amd_Ajv_root_Ajv_default.a().compile({
  oneOf: [{
    type: 'object',
    required: ['field_name', 'op', 'value'],
    properties: {
      field_name: { type: 'string' },
      op: {
        type: 'string',
        enum: ['EQ', 'NEQ', 'IN', 'NIN', 'LT', 'LTE', 'GT', 'GTE', 'BWITH', 'EWITH', 'CONTAINS', 'NCONTAIN', 'RANGE', 'NRANGE', 'DOW', 'NDOW']
      },
      value: { type: ['number', 'string', 'boolean', 'null'] }
    }
  }, {
    type: 'object',
    required: ['field_name', 'op'],
    properties: {
      field_name: { type: 'string' },
      op: {
        type: 'string',
        enum: ['EMPTY', 'NEMPTY', 'TRUE', 'FALSE']
      }
    }
  }]
});

// -----------------------------------------------------
// Class Definition
// -----------------------------------------------------

var ItemProvider = function () {
  function ItemProvider(node, name) {
    var providesControl = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

    ItemProvider_classCallCheck(this, ItemProvider);

    this.adapter = {
      matcher: ItemProvider_matcher,
      transformIn: function transformIn(data) {
        return data;
      },
      transformOut: function transformOut(data) {
        return data;
      },
      create: function create() {
        return { field_name: '', op: 'EQ', value: '' };
      },
      node: node,
      name: name,
      providesControl: providesControl
    };
  }

  ItemProvider_createClass(ItemProvider, [{
    key: 'getAdapter',
    value: function getAdapter() {
      return this.adapter;
    }
  }]);

  return ItemProvider;
}();

// -----------------------------------------------------
// Exports
// -----------------------------------------------------

/* harmony default export */ var providers_ItemProvider = (ItemProvider);
// CONCATENATED MODULE: ./src/providers/ScopedGroupProvider.js
var ScopedGroupProvider_createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function ScopedGroupProvider_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }



// -----------------------------------------------------
// Helpers
// -----------------------------------------------------

var ScopedGroupProvider_matcher = new external_commonjs_ajv_commonjs2_ajv_amd_Ajv_root_Ajv_default.a().compile({
  type: 'object',
  required: ['scope', 'conditions'],
  properties: {
    scope: { type: 'string' },
    conditions: {
      type: 'object',
      oneOf: [{
        required: ['and'],
        properties: {
          and: { type: 'array' }
        }
      }, {
        required: ['or'],
        properties: {
          or: { type: 'array' }
        }
      }]
    }
  }
});

function ScopedGroupProvider_create() {
  return {
    scope: '',
    conditions: { and: [{ field_name: '', op: '', value: '' }] }
  };
}

// -----------------------------------------------------
// Class Definition
// -----------------------------------------------------

var ScopedGroupProvider = function () {
  function ScopedGroupProvider(node, name) {
    var providesControl = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

    ScopedGroupProvider_classCallCheck(this, ScopedGroupProvider);

    this.adapter = {
      matcher: ScopedGroupProvider_matcher,
      transformIn: function transformIn(data) {
        return data;
      },
      transformOut: function transformOut(data) {
        return data;
      },
      create: ScopedGroupProvider_create,
      node: node,
      name: name,
      providesControl: providesControl
    };
  }

  ScopedGroupProvider_createClass(ScopedGroupProvider, [{
    key: 'getAdapter',
    value: function getAdapter() {
      return this.adapter;
    }
  }]);

  return ScopedGroupProvider;
}();

// -----------------------------------------------------
// Exports
// -----------------------------------------------------

/* harmony default export */ var providers_ScopedGroupProvider = (ScopedGroupProvider);
// CONCATENATED MODULE: ./src/components/Control/DateInput.js
var DateInput_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function DateInput_objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }




// -----------------------------------------------------
// Component Definition
// -----------------------------------------------------

var DateInput_DateInput = function DateInput(_ref) {
  var name = _ref.name,
      value = _ref.value,
      onChange = _ref.onChange,
      forwardProps = DateInput_objectWithoutProperties(_ref, ['name', 'value', 'onChange']);

  return external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.createElement('input', DateInput_extends({}, forwardProps, {
    name: name,
    type: 'date',
    value: value,
    onChange: onChange }));
};

// -----------------------------------------------------
// PropTypes
// -----------------------------------------------------

DateInput_DateInput.propTypes = {
  value: external_commonjs_prop_types_commonjs2_prop_types_amd_PropTypes_root_PropTypes_default.a.string,
  name: external_commonjs_prop_types_commonjs2_prop_types_amd_PropTypes_root_PropTypes_default.a.string.isRequired,
  onChange: external_commonjs_prop_types_commonjs2_prop_types_amd_PropTypes_root_PropTypes_default.a.func.isRequired
};

// -----------------------------------------------------
// Exports
// -----------------------------------------------------

/* harmony default export */ var Control_DateInput = (DateInput_DateInput);
// CONCATENATED MODULE: ./src/components/Control/EmailInput.js
var EmailInput_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function EmailInput_objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }




// -----------------------------------------------------
// Component Definition
// -----------------------------------------------------

var EmailInput_EmailInput = function EmailInput(_ref) {
  var name = _ref.name,
      value = _ref.value,
      onChange = _ref.onChange,
      forwardProps = EmailInput_objectWithoutProperties(_ref, ['name', 'value', 'onChange']);

  return external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.createElement('input', EmailInput_extends({}, forwardProps, {
    name: name,
    type: 'email',
    value: value,
    onChange: onChange }));
};

// -----------------------------------------------------
// PropTypes
// -----------------------------------------------------

EmailInput_EmailInput.propTypes = {
  value: external_commonjs_prop_types_commonjs2_prop_types_amd_PropTypes_root_PropTypes_default.a.string,
  name: external_commonjs_prop_types_commonjs2_prop_types_amd_PropTypes_root_PropTypes_default.a.string.isRequired,
  onChange: external_commonjs_prop_types_commonjs2_prop_types_amd_PropTypes_root_PropTypes_default.a.func.isRequired
};

// -----------------------------------------------------
// Exports
// -----------------------------------------------------

/* harmony default export */ var Control_EmailInput = (EmailInput_EmailInput);
// CONCATENATED MODULE: ./src/components/Control/NumberInput.js
var NumberInput_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function NumberInput_objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }




// -----------------------------------------------------
// Component Definition
// -----------------------------------------------------

var NumberInput_NumberInput = function NumberInput(_ref) {
  var name = _ref.name,
      value = _ref.value,
      onChange = _ref.onChange,
      forwardProps = NumberInput_objectWithoutProperties(_ref, ['name', 'value', 'onChange']);

  return external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.createElement('input', NumberInput_extends({}, forwardProps, {
    name: name,
    type: 'number',
    value: value,
    onChange: onChange }));
};

// -----------------------------------------------------
// PropTypes
// -----------------------------------------------------

NumberInput_NumberInput.propTypes = {
  value: external_commonjs_prop_types_commonjs2_prop_types_amd_PropTypes_root_PropTypes_default.a.string,
  name: external_commonjs_prop_types_commonjs2_prop_types_amd_PropTypes_root_PropTypes_default.a.string.isRequired,
  onChange: external_commonjs_prop_types_commonjs2_prop_types_amd_PropTypes_root_PropTypes_default.a.func.isRequired
};

// -----------------------------------------------------
// Exports
// -----------------------------------------------------

/* harmony default export */ var Control_NumberInput = (NumberInput_NumberInput);
// CONCATENATED MODULE: ./src/components/Control/SelectInput.js
var SelectInput_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function SelectInput_objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }




// -----------------------------------------------------
// Component Definition
// -----------------------------------------------------

var SelectInput_SelectInput = function SelectInput(_ref) {
  var name = _ref.name,
      value = _ref.value,
      onChange = _ref.onChange,
      options = _ref.options,
      multiple = _ref.multiple,
      includeBlankOption = _ref.includeBlankOption,
      forwardProps = SelectInput_objectWithoutProperties(_ref, ['name', 'value', 'onChange', 'options', 'multiple', 'includeBlankOption']);

  var normValue = multiple ? [].concat(value) : value;

  return external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.createElement(
    'select',
    SelectInput_extends({}, forwardProps, {
      multiple: multiple,
      name: name,
      value: normValue,
      onChange: onChange }),
    includeBlankOption && external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.createElement('option', null),
    (options || []).map(function (_ref2) {
      var value = _ref2.value,
          label = _ref2.label;
      return external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.createElement(
        'option',
        { key: value, value: value },
        label
      );
    })
  );
};

// -----------------------------------------------------
// PropTypes
// -----------------------------------------------------

SelectInput_SelectInput.defaultProps = {
  multiple: false,
  includeBlankOption: false
};

SelectInput_SelectInput.propTypes = {
  multiple: external_commonjs_prop_types_commonjs2_prop_types_amd_PropTypes_root_PropTypes_default.a.bool,
  includeBlankOption: external_commonjs_prop_types_commonjs2_prop_types_amd_PropTypes_root_PropTypes_default.a.bool,

  value: external_commonjs_prop_types_commonjs2_prop_types_amd_PropTypes_root_PropTypes_default.a.oneOfType([external_commonjs_prop_types_commonjs2_prop_types_amd_PropTypes_root_PropTypes_default.a.string, external_commonjs_prop_types_commonjs2_prop_types_amd_PropTypes_root_PropTypes_default.a.number, external_commonjs_prop_types_commonjs2_prop_types_amd_PropTypes_root_PropTypes_default.a.array]),

  name: external_commonjs_prop_types_commonjs2_prop_types_amd_PropTypes_root_PropTypes_default.a.string.isRequired,
  options: external_commonjs_prop_types_commonjs2_prop_types_amd_PropTypes_root_PropTypes_default.a.arrayOf(external_commonjs_prop_types_commonjs2_prop_types_amd_PropTypes_root_PropTypes_default.a.shape({
    value: external_commonjs_prop_types_commonjs2_prop_types_amd_PropTypes_root_PropTypes_default.a.oneOfType([external_commonjs_prop_types_commonjs2_prop_types_amd_PropTypes_root_PropTypes_default.a.string, external_commonjs_prop_types_commonjs2_prop_types_amd_PropTypes_root_PropTypes_default.a.number, external_commonjs_prop_types_commonjs2_prop_types_amd_PropTypes_root_PropTypes_default.a.bool]),
    label: external_commonjs_prop_types_commonjs2_prop_types_amd_PropTypes_root_PropTypes_default.a.string
  })).isRequired,

  onChange: external_commonjs_prop_types_commonjs2_prop_types_amd_PropTypes_root_PropTypes_default.a.func.isRequired
};

// -----------------------------------------------------
// Exports
// -----------------------------------------------------

/* harmony default export */ var Control_SelectInput = (SelectInput_SelectInput);
// CONCATENATED MODULE: ./src/components/Control/TextInput.js
var TextInput_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function TextInput_objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }




// -----------------------------------------------------
// Component Definition
// -----------------------------------------------------

var TextInput_TextInput = function TextInput(_ref) {
  var name = _ref.name,
      value = _ref.value,
      onChange = _ref.onChange,
      forwardProps = TextInput_objectWithoutProperties(_ref, ['name', 'value', 'onChange']);

  return external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.createElement('input', TextInput_extends({}, forwardProps, {
    name: name,
    type: 'text',
    value: value,
    onChange: onChange }));
};

// -----------------------------------------------------
// PropTypes
// -----------------------------------------------------

TextInput_TextInput.propTypes = {
  value: external_commonjs_prop_types_commonjs2_prop_types_amd_PropTypes_root_PropTypes_default.a.string,
  name: external_commonjs_prop_types_commonjs2_prop_types_amd_PropTypes_root_PropTypes_default.a.string.isRequired,
  onChange: external_commonjs_prop_types_commonjs2_prop_types_amd_PropTypes_root_PropTypes_default.a.func.isRequired
};

// -----------------------------------------------------
// Exports
// -----------------------------------------------------

/* harmony default export */ var Control_TextInput = (TextInput_TextInput);
// CONCATENATED MODULE: ./src/components/Control/TimeInput.js
var TimeInput_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function TimeInput_objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }




// -----------------------------------------------------
// Component Definition
// -----------------------------------------------------

var TimeInput_TimeInput = function TimeInput(_ref) {
  var name = _ref.name,
      value = _ref.value,
      onChange = _ref.onChange,
      forwardProps = TimeInput_objectWithoutProperties(_ref, ['name', 'value', 'onChange']);

  return external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.createElement('input', TimeInput_extends({}, forwardProps, {
    name: name,
    type: 'text',
    value: value,
    onChange: onChange }));
};

// -----------------------------------------------------
// PropTypes
// -----------------------------------------------------

TimeInput_TimeInput.propTypes = {
  value: external_commonjs_prop_types_commonjs2_prop_types_amd_PropTypes_root_PropTypes_default.a.string,
  name: external_commonjs_prop_types_commonjs2_prop_types_amd_PropTypes_root_PropTypes_default.a.string.isRequired,
  onChange: external_commonjs_prop_types_commonjs2_prop_types_amd_PropTypes_root_PropTypes_default.a.func.isRequired
};

// -----------------------------------------------------
// Exports
// -----------------------------------------------------

/* harmony default export */ var Control_TimeInput = (TimeInput_TimeInput);
// CONCATENATED MODULE: ./src/components/Control/index.js






// CONCATENATED MODULE: ./src/index.js
/* concated harmony reexport ConditionGroup */__webpack_require__.d(__webpack_exports__, "ConditionGroup", function() { return components_ConditionGroup; });
/* concated harmony reexport Control */__webpack_require__.d(__webpack_exports__, "Control", function() { return Control_namespaceObject; });
/* concated harmony reexport Item */__webpack_require__.d(__webpack_exports__, "Item", function() { return components_Item; });
/* concated harmony reexport Registry */__webpack_require__.d(__webpack_exports__, "Registry", function() { return providers_Registry; });
/* concated harmony reexport GroupProvider */__webpack_require__.d(__webpack_exports__, "GroupProvider", function() { return providers_GroupProvider; });
/* concated harmony reexport ItemProvider */__webpack_require__.d(__webpack_exports__, "ItemProvider", function() { return providers_ItemProvider; });
/* concated harmony reexport ScopedGroupProvider */__webpack_require__.d(__webpack_exports__, "ScopedGroupProvider", function() { return providers_ScopedGroupProvider; });
var src_createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function src_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function src_possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function src_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }


















// -----------------------------------------------------
// Component
// -----------------------------------------------------

var src_ConditionalEditor = function (_Component) {
  src_inherits(ConditionalEditor, _Component);

  function ConditionalEditor(props) {
    src_classCallCheck(this, ConditionalEditor);

    var _this = src_possibleConstructorReturn(this, (ConditionalEditor.__proto__ || Object.getPrototypeOf(ConditionalEditor)).call(this, props));

    rebind("handleRemove", _this);
    return _this;
  }

  src_createClass(ConditionalEditor, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          conditions = _props.conditions,
          fields = _props.fields,
          registry = _props.registry,
          onChange = _props.onChange,
          fieldsControl = _props.fieldsControl,
          opsControl = _props.opsControl,
          valuesDateControl = _props.valuesDateControl,
          valuesTimeControl = _props.valuesTimeControl,
          valuesTextControl = _props.valuesTextControl,
          valuesEmailControl = _props.valuesEmailControl,
          valuesNumberControl = _props.valuesNumberControl,
          valuesSelectOneControl = _props.valuesSelectOneControl,
          valuesSelectManyControl = _props.valuesSelectManyControl;


      return external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.createElement(components_ProviderNode, { condition: conditions,
        fields: fields,
        registry: registry,
        fieldsControl: fieldsControl,
        opsControl: opsControl,
        valuesDateControl: valuesDateControl,
        valuesTimeControl: valuesTimeControl,
        valuesTextControl: valuesTextControl,
        valuesEmailControl: valuesEmailControl,
        valuesNumberControl: valuesNumberControl,
        valuesSelectOneControl: valuesSelectOneControl,
        valuesSelectManyControl: valuesSelectManyControl,
        onChange: onChange,
        onRemove: this.handleRemove });
    }
  }, {
    key: 'handleRemove',
    value: function handleRemove() {
      var onChange = this.props.onChange;

      onChange({ conditions: {} });
    }
  }]);

  return ConditionalEditor;
}(external_commonjs_react_commonjs2_react_amd_React_root_React_["Component"]);

;

// -----------------------------------------------------
// PropTypes
// -----------------------------------------------------

src_ConditionalEditor.defaultProps = {
  fieldsControl: Control_SelectInput,
  opsControl: Control_SelectInput,
  valuesDateControl: Control_DateInput,
  valuesTimeControl: Control_TimeInput,
  valuesTextControl: Control_TextInput,
  valuesEmailControl: Control_EmailInput,
  valuesNumberControl: Control_NumberInput,
  valuesSelectOneControl: Control_SelectInput,
  valuesSelectManyControl: Control_SelectInput
};

src_ConditionalEditor.propTypes = {
  conditions: external_commonjs_prop_types_commonjs2_prop_types_amd_PropTypes_root_PropTypes_default.a.object.isRequired,
  fields: propTypes_fields.isRequired,
  registry: external_commonjs_prop_types_commonjs2_prop_types_amd_PropTypes_root_PropTypes_default.a.instanceOf(providers_Registry).isRequired,
  onChange: external_commonjs_prop_types_commonjs2_prop_types_amd_PropTypes_root_PropTypes_default.a.func.isRequired,
  fieldsControl: external_commonjs_prop_types_commonjs2_prop_types_amd_PropTypes_root_PropTypes_default.a.oneOfType([external_commonjs_prop_types_commonjs2_prop_types_amd_PropTypes_root_PropTypes_default.a.func, external_commonjs_prop_types_commonjs2_prop_types_amd_PropTypes_root_PropTypes_default.a.instanceOf(external_commonjs_react_commonjs2_react_amd_React_root_React_["Component"])]),
  opsControl: external_commonjs_prop_types_commonjs2_prop_types_amd_PropTypes_root_PropTypes_default.a.oneOfType([external_commonjs_prop_types_commonjs2_prop_types_amd_PropTypes_root_PropTypes_default.a.func, external_commonjs_prop_types_commonjs2_prop_types_amd_PropTypes_root_PropTypes_default.a.instanceOf(external_commonjs_react_commonjs2_react_amd_React_root_React_["Component"])]),
  valuesDateControl: external_commonjs_prop_types_commonjs2_prop_types_amd_PropTypes_root_PropTypes_default.a.oneOfType([external_commonjs_prop_types_commonjs2_prop_types_amd_PropTypes_root_PropTypes_default.a.func, external_commonjs_prop_types_commonjs2_prop_types_amd_PropTypes_root_PropTypes_default.a.instanceOf(external_commonjs_react_commonjs2_react_amd_React_root_React_["Component"])]),
  valuesTimeControl: external_commonjs_prop_types_commonjs2_prop_types_amd_PropTypes_root_PropTypes_default.a.oneOfType([external_commonjs_prop_types_commonjs2_prop_types_amd_PropTypes_root_PropTypes_default.a.func, external_commonjs_prop_types_commonjs2_prop_types_amd_PropTypes_root_PropTypes_default.a.instanceOf(external_commonjs_react_commonjs2_react_amd_React_root_React_["Component"])]),
  valuesTextControl: external_commonjs_prop_types_commonjs2_prop_types_amd_PropTypes_root_PropTypes_default.a.oneOfType([external_commonjs_prop_types_commonjs2_prop_types_amd_PropTypes_root_PropTypes_default.a.func, external_commonjs_prop_types_commonjs2_prop_types_amd_PropTypes_root_PropTypes_default.a.instanceOf(external_commonjs_react_commonjs2_react_amd_React_root_React_["Component"])]),
  valuesEmailControl: external_commonjs_prop_types_commonjs2_prop_types_amd_PropTypes_root_PropTypes_default.a.oneOfType([external_commonjs_prop_types_commonjs2_prop_types_amd_PropTypes_root_PropTypes_default.a.func, external_commonjs_prop_types_commonjs2_prop_types_amd_PropTypes_root_PropTypes_default.a.instanceOf(external_commonjs_react_commonjs2_react_amd_React_root_React_["Component"])]),
  valuesNumberControl: external_commonjs_prop_types_commonjs2_prop_types_amd_PropTypes_root_PropTypes_default.a.oneOfType([external_commonjs_prop_types_commonjs2_prop_types_amd_PropTypes_root_PropTypes_default.a.func, external_commonjs_prop_types_commonjs2_prop_types_amd_PropTypes_root_PropTypes_default.a.instanceOf(external_commonjs_react_commonjs2_react_amd_React_root_React_["Component"])]),
  valuesSelectOneControl: external_commonjs_prop_types_commonjs2_prop_types_amd_PropTypes_root_PropTypes_default.a.oneOfType([external_commonjs_prop_types_commonjs2_prop_types_amd_PropTypes_root_PropTypes_default.a.func, external_commonjs_prop_types_commonjs2_prop_types_amd_PropTypes_root_PropTypes_default.a.instanceOf(external_commonjs_react_commonjs2_react_amd_React_root_React_["Component"])]),
  valuesSelectManyControl: external_commonjs_prop_types_commonjs2_prop_types_amd_PropTypes_root_PropTypes_default.a.oneOfType([external_commonjs_prop_types_commonjs2_prop_types_amd_PropTypes_root_PropTypes_default.a.func, external_commonjs_prop_types_commonjs2_prop_types_amd_PropTypes_root_PropTypes_default.a.instanceOf(external_commonjs_react_commonjs2_react_amd_React_root_React_["Component"])])

  // -----------------------------------------------------
  // Exports
  // -----------------------------------------------------

};

/* harmony default export */ var src = __webpack_exports__["default"] = (src_ConditionalEditor);

/***/ })
/******/ ]);
});